import { render, staticRenderFns } from "./MainAccountDetailed.vue?vue&type=template&id=d0bbd1bc&scoped=true"
import script from "./MainAccountDetailed.vue?vue&type=script&lang=js"
export * from "./MainAccountDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bbd1bc",
  null
  
)

export default component.exports